export default "__VITE_ASSET__0b1bd874__"